import { css, keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const loadingAnimation = keyframes`
  0% {
    background-position: 60% 50%;
  }

  100% {
    background-position: -100% 50%;
  }
`

const baseStyles = () => css`
  label: shell;

  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Shell = styled('div')(baseStyles)

const itemStyles = ({ theme }) => css`
  label: shell__item;

  animation: ${loadingAnimation} 2s ease infinite;
  background: linear-gradient(90deg, ${theme.colors.n100} 0, ${theme.colors.white} 20%, ${theme.colors.n100} 40%, ${theme.colors.n100});
  background-size: 200% 100%;
  display: block;
  margin-right: ${theme.spacings.mega};
  width: 80px;
  height: 13px;
`

export const Item = styled('div')(itemStyles)
